export const intervalTimesInMilliseconds = {
  closeExpandedSidenav: 100,
  hoverIntent: 100,
  hoverSelection: 200,
};

export const highlightColor = `rgba(255,255,255,0.08)`;
